import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../common/SEO';
import Layout from '../common/Layout';
import Button from '../components/ui/Button';
import { Eyebrow } from '../components/ui/SectionHead';
import Notice from '../components/ui/Notice';

const NotFound = () => {
  const { t } = useTranslation('cy');
  const meta = t('notfound.meta', { returnObjects: true });

  return (
    <Layout>
      <SEO title={meta.title} description={meta.description} noindex />

      <section className="cy-section cy-error-page" id="error-404-message">
        <div className="cy-container cy-error-page__inner">
          <Eyebrow>{t('notfound.eyebrow')}</Eyebrow>
          <h1 className="cy-h1">{t('notfound.h1')}</h1>
          <p className="cy-lede cy-error-page__lede">{t('notfound.body')}</p>
          <div className="cy-section-action">
            <Button to="/">{t('notfound.cta')}</Button>
          </div>
          <p className="cy-fineprint cy-section-note">{t('notfound.services')}</p>
          <div className="cy-error-page__links">
            {t('notfound.links', { returnObjects: true }).map((l) => (
              <Link className="cy-link" key={l.to} to={l.to}>{l.label}</Link>
            ))}
          </div>
        </div>
      </section>

      <section className="cy-section cy-section--alt" id="error-404-help">
        <div className="cy-container cy-error-page__inner">
          <h2 className="cy-title">{t('notfound.help.h2')}</h2>
          <p className="cy-lede cy-error-page__lede">{t('notfound.help.body')}</p>
          <div className="cy-error-page__links">
            <Link className="cy-link" to="/contact">{t('notfound.help.contact')}</Link>
            <Link className="cy-link" to="/submit-opportunity">{t('notfound.help.submit')}</Link>
          </div>
          <Notice variant="inline" className="cy-notice--follow">{t('notfound.help.warning')}</Notice>
        </div>
      </section>
    </Layout>
  );
};

export default NotFound;
